<template>
  <div v-if="isLoading" class="text-center">
    <ProgressSpinner />
  </div>
  <!--    :x="175" переделанно на eventHundler в eventHandlerContainer-->
  <ContainerBase v-show="!isLoading" :y="72" :properties="$store.getters.dataProp" :events="$store.getters.event"
    :childList="itemList" v-if="itemList">
  </ContainerBase>
  <Dialog v-model:visible="restoreDialog" :style="{ width: '550px' }" modal>
    <template #header>
      <i class="pi pi-question-circle mr-3" style="font-size: 2rem; color: rgb(204,204,0)" />
      <div class="col-10 font-bold text-center" style="font-size: 1.3rem">
        Подтверждение действий
      </div>
    </template>

    <div class="confirmation-content">
      <div class="text-center">
        <span style="font-size: 1.1rem">Восстановить дизайн из dfm ?</span>
      </div>
    </div>
    <template #footer>
      <Button label="Нет" icon="pi pi-times" class="p-button-text" @click="restoreDialog = false" />
      <Button label="Да" icon="pi pi-check" class="p-button-text" @click="restoreDFM()" />
    </template>
  </Dialog>
</template>

<script setup>
import { ref, watch, onMounted, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'primevue/usetoast';
import ContainerBase from './container_base.vue';
import Converter from '../utils/Converter.js';
import EventBus from '@/core/EventBus';

const toast = useToast();

const props = defineProps({
  scriptId: {},
  defaultScript: {},
});

const store = useStore();

const data = ref(null);
const isLoading = ref(false);
const isDefaultScript = ref(true);
const restoreDialog = ref(false);
const intervalLoad = ref(null);
const itemList = ref([]);
const itemListTemp = ref([]);
const scriptService = ref(null);

const getFreeId = (items, id = 'id') => {
  const set = new Set(Array.from(items, (item) => Number(item[id])));
  const setWith = new Set(
    Array(items.length + 1)
      .fill()
      .map((e, i) => i)
  );
  const difference = new Set([...setWith].filter((x) => !set.has(x)));
  let result = items.length;
  if (difference.size) result = difference.values().next().value;
  return result;
};

const prepeaUpdate = (itemList) => {
  const result = [];
  for (let i = 0; i < itemList.length; i++) {
    let item = { ...itemList[i] };
    if (item?.isDontSave) continue;
    item.attrList.x = Math.round(item.attrList.x);
    item.attrList.y = Math.round(item.attrList.y);
    item.attrList.width = Math.round(item.attrList.width);
    item.attrList.height = Math.round(item.attrList.height);
    delete item.attrList.id;
    result.push(item);
  }
  return result;
};

const onShowRestoreDialog = () => {
  restoreDialog.value = true;
  console.warn('Предлагаем восстановить дизайн');
};

const getDesignData = () => {
  isLoading.value = true;
  scriptService.value = store.getters.nameToService(
    'BaseService',
    store.getters.info.login,
    store.getters.password,
    'script',
    'row'
  );
  scriptService.value
    .getData({ script_id: props.scriptId })
    .then((d) => {
      data.value = d[0];
      prepeaListItem(JSON.parse(d[0].design_web));
      if (!d[0].design_web && d[0].design_form) {
        onShowRestoreDialog();
      }
      isDefaultScript.value = false;
    })
    .catch((er) => store.commit('SET_ERROR', { er }))
    .finally(() => {
      isLoading.value = false;
    });
};

const prepeaListItem = (d, createId = false) => {
  const itemListTempArr = [];
  let maxY = 0;
  let i = 0;
  if (d) {
    for (const item of d) {
      if (createId) itemListTempArr.push({ ...item, id: i });
      else itemListTempArr.push({ ...item });
      i++;
      if (item?.attrList?.y + item?.attrList?.height > maxY) {
        maxY = item.attrList.y + item.attrList.height;
      }
    }
  }
  store.dispatch('setDesignWeb', itemListTempArr);
  store.dispatch('setMaxY', maxY);
  EventBus.emit('on-start-execution', 'property');
  itemList.value = itemListTempArr;
};

const restoreDFM = () => {
  isLoading.value = true;
  restoreDialog.value = false;
  const converter = new Converter();
  const jsonDesign = converter.DFMToJSON(data.value.design_form, store);
  itemList.value = null;
  setTimeout(() => {
    prepeaListItem(jsonDesign, true);
    isLoading.value = false;
  }, 250);
};

watch(
  () => props.scriptId,
  (val) => {
    // EventBus.emit("on-check-save-script");
    EventBus.emit('on-stop-update-property');
    if (val) {
      getDesignData();
    } else if (props.defaultScript) {
      const { design, changeScript, proccessScript } = props.defaultScript;
      data.value = {
        design_web: design,
        facility_changed_script: changeScript,
        facility_process_script: proccessScript,
      };
      setTimeout(() => {
        if (isDefaultScript.value) {
          prepeaListItem(JSON.parse(data.value.design_web));
        }
      }, 300);
    }
  },
  { immediate: true }
);

onMounted(() => {
  EventBus.on('on-update-component', (component) => {
    for (let item of itemList.value) {
      if (item.typeName + item.id === component.id) {
        item.attrList = { ...component };
        item.attrList.x = Number(component.x);
        item.attrList.y = Number(component.y);
        item.attrList.width = Number(component.width);
        item.attrList.height = Number(component.height);
        for (const elem in item.attrList) {
          if (item.attrList[elem] === '') item.attrList[elem] = null;
        }
        EventBus.emit('on-change-save');
      }
    }
  });

  EventBus.on('on-delete-component', (id) => {
    let i = 0;
    for (let item of itemList.value) {
      if (item.typeName + item.id === id) {
        itemList.value.splice(i, 1);
        EventBus.emit('on-change-save');
        break;
      }
      i++;
    }
  });

  EventBus.on('on-get-component-copy', (id) => {
    for (const item of itemList.value) {
      if (item.typeName + item.id === id) {
        EventBus.emit('on-set-component-copy', item);
        return;
      }
    }
  });

  EventBus.on('on-save-facility', () => {
    if (data.value) {
      isLoading.value = true;
      data.value.design_web = JSON.stringify(prepeaUpdate(itemList.value));
      scriptService.value
        .putData({ script_id: props.scriptId, design_web: data.value.design_web }, 'web')
        .then(() =>
          toast.add({
            severity: 'success',
            summary: 'Дизайн объекта сохранён',
            detail: 'Изменения в схеме успешно сохранены',
            life: 3000,
          })
        )
        .catch((er) => {
          store.commit('SET_ERROR', er);
        })
        .finally(() => {
          EventBus.emit('on-change-save', false);
          isLoading.value = false;
        });
    }
  });

  EventBus.on('on-create-component-select', (elem) => {
    const component = { ...elem };
    component.attrList = { ...elem.attrList };
    component.attrList.x = Math.round(document.documentElement.clientWidth / 3);
    component.attrList.y = Math.round(document.documentElement.clientHeight / 3);
    delete component.attrList.id;
    component.id = getFreeId(itemList.value);
    component.attrList.tag = component.typeName + component.id;
    console.log('on-create-component-select', component);

    itemList.value.push(component);
    EventBus.emit('on-change-save');
    EventBus.emit('on-target-component', component);
    EventBus.emit('on-insert-moveable', component);
  });

  EventBus.on('on-create-component', (elem) => {
    elem.id = getFreeId(itemList.value);
    itemList.value.push({ ...elem });
  });

  EventBus.on('on-recovery-component', (elem) => {
    itemList.value.push({ ...elem });
  });
});

onBeforeUnmount(() => {
  if (intervalLoad.value) clearInterval(intervalLoad.value);
  EventBus.off('on-create-component-select');
  EventBus.off('on-create-component');
  EventBus.off('on-recovery-component');
  EventBus.off('on-save-facility');
  EventBus.off('on-delete-component');
  EventBus.off('on-update-component');
  EventBus.off('on-get-component-copy');
});
</script>

<style>
/* 
если захотим прятать обрамление moveable
.moveable-line {
      display: none;
}
.moveable-origin {
      display: none;
} */
</style>
